import { FC } from 'react';
import { Outlet } from 'react-router';

import { IS_HAPPYDESK_CHAT } from '@/shared/config';
import { useHappydeskChat, useHubspotChat } from '@/shared/hooks';

import { KnowledgeBase } from '@/widgets/KnowledgeBase';

const HappydeskRoutes: FC = () => {
  useHappydeskChat();
  return <Outlet />;
};

const HubspotRoutes: FC = () => {
  useHubspotChat();
  return <Outlet />;
};

export const ChatRoutes: FC = () => {
  if (IS_HAPPYDESK_CHAT) {
    return <HappydeskChatTree />;
  }
  return <HubspotChatTree />;
};

// The KB panel mounts at the route-tree root: the header shows the trigger
// button on auth pages too, so the panel must exist there as well.
const HappydeskChatTree: FC = () => (
  <>
    <HappydeskRoutes />
    <KnowledgeBase />
  </>
);

const HubspotChatTree: FC = () => (
  <>
    <HubspotRoutes />
    <KnowledgeBase />
  </>
);
